import { ref, type Ref } from 'vue';

// Bridges the Monaco quick-fix ("Create service …" on a not-found $__ref squiggle) to
// the app-root NewServiceDialog. Same pattern as secretCreatePrompt.ts: the code action
// runs in a side-effect lib with no Vue context, so it sets a request here and the
// global <NewServiceDialog> in App.vue reacts.
export const newServiceRequest: Ref<{ name: string } | null> = ref(null);

// `name` is the folder name the editor flagged as unresolved. The dialog opens prefilled
// so the operator can add a display name / category / description like a normal create.
export function requestNewService(name: string): void {
  newServiceRequest.value = { name };
}

export function clearNewServiceRequest(): void {
  newServiceRequest.value = null;
}
